export const SAVE_PATIENT_PROFILE_REQUEST = "SAVE_PATIENT_PROFILE_REQUEST";
export const SAVE_PATIENT_PROFILE_SUCCESS = "SAVE_PATIENT_PROFILE_SUCCESS";
export const SAVE_PATIENT_PROFILE_ERROR = "SAVE_PATIENT_PROFILE_ERROR";
